import { ModificationRequestState as State } from '@kaizenplatform/hugot-entity';
import { Badge, Tooltip } from '@material-ui/core';
import Forum from '@material-ui/icons/Forum';
import WarningRounded from '@material-ui/icons/WarningRounded';
import { ClassAttributes, createElement } from 'react';
import { FormattedMessage } from 'react-intl';

interface Props {
  state: State;
  unresolvedIssueCount?: number;
}

const ModificationRequestStateIcon = ({ state, unresolvedIssueCount }: ClassAttributes<HTMLElement> & Props) => {
  switch (state) {
    case 'submitted':
    case 'responded': {
      return (
        <FormattedMessage id="modification_request_state.submitted">
          {(state: string) => (
            <Tooltip placement="top" title={state}>
              {unresolvedIssueCount && unresolvedIssueCount > 0 ? (
                <Badge badgeContent={unresolvedIssueCount} color="primary">
                  <Forum />
                </Badge>
              ) : (
                <Forum />
              )}
            </Tooltip>
          )}
        </FormattedMessage>
      );
    }
    case 'given_feedback': {
      return (
        <FormattedMessage id="modification_request_state.given_feedback">
          {(state: string) => (
            <Tooltip placement="top" title={state}>
              <WarningRounded style={{ color: '#f9a825' }} />
            </Tooltip>
          )}
        </FormattedMessage>
      );
    }
    default: {
      return null;
    }
  }
};

export default ModificationRequestStateIcon;
